import { injectWalkMeScript, isIframeAccessible } from '@alchemer/walkme-config';
import { getWalkMeEnvironment } from '@/lib/env';

export function injectWalkMe(targetFrame?: HTMLIFrameElement) {
  const environment = getWalkMeEnvironment();

  if (targetFrame) {
    if (!isIframeAccessible(targetFrame)) {
      console.warn('Cannot inject WalkMe into inaccessible iframe');
      return;
    }
    injectWalkMeScript(environment, targetFrame);
    return;
  }

  injectWalkMeScript(environment);
}
